// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// GetResourcesHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import ResourceDTO from '../models/ResourceDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
        },
        initValues);
    },
}

interface Result extends ResultDTO {
    resources: ResourceDTO[] | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            resources: [],
        },
        initValues);
    },
    resources: 'resources',
}

export { Request, Result };